import { UnitName } from "#shared/view/designSystem/inputs/units";
import {
  computeVolumeM3,
  isMachiningDimensions,
  isSheetPartType,
  PartTypeSchema,
  PartTypeType,
} from "shared";

type UnitFactor = { value: number; unit: UnitName };

type ByMaterialTypesParams = {
  partType: PartTypeType;
  material: {
    densityKgDm3: number;
    height: number;
    length: number;
    width: number;
    tubeThickness: number;
  };
};

export const getUnitFactorsByMaterialType = ({
  partType,
  material,
}: ByMaterialTypesParams): UnitFactor[] | undefined => {
  const volumeM3 = computeVolumeM3({
    partType,
    length: material.length,
    width: material.width,
    height: material.height,
    tubeThickness: material.tubeThickness,
  });

  const surfaceM2 = (material.length / 1000) * (material.width / 1000);

  const weightKg = material.densityKgDm3 * 1000 * volumeM3;

  const eByM3: UnitFactor | undefined = volumeM3
    ? { value: 1 / volumeM3, unit: "€/m3" }
    : undefined;

  const eByM2: UnitFactor | undefined = surfaceM2
    ? { value: 1 / surfaceM2, unit: "€/m2" }
    : undefined;

  const eByM: UnitFactor | undefined = material.length
    ? { value: 1 / (material.length / 1000), unit: "€/m" }
    : undefined;

  const eByTon: UnitFactor | undefined = weightKg
    ? {
        value: 1 / (weightKg / 1000),
        unit: "€/tonne",
      }
    : undefined;

  const eByKg: UnitFactor | undefined = weightKg
    ? { value: 1 / weightKg, unit: "€/kg" }
    : undefined;

  if (isSheetPartType(partType)) {
    const filteredFactors: (UnitFactor | undefined)[] = [eByM2, eByKg, eByTon].filter(
      (factor) => factor,
    );

    return filteredFactors as UnitFactor[];
  } else if (
    partType === PartTypeSchema.enum.ROUND_TUBE ||
    partType === PartTypeSchema.enum.SQUARE_TUBE ||
    partType === PartTypeSchema.enum.ROUND_BAR ||
    partType === PartTypeSchema.enum.SQUARE_BAR
  ) {
    const filteredFactors: (UnitFactor | undefined)[] = [eByM, eByM3, eByKg, eByTon].filter(
      (factor) => factor,
    );

    return filteredFactors as UnitFactor[];
  } else if (isMachiningDimensions({ partType })) {
    const filteredFactors: (UnitFactor | undefined)[] = [eByM3, eByKg, eByTon].filter(
      (factor) => factor,
    );

    return filteredFactors as UnitFactor[];
  }

  return undefined;
};
